module.exports = __webpack_public_path__ + "img/icon-1.17a6bb96.svg";